import type { InstantCashFeatures } from './type';

export const instantCash: InstantCashFeatures = {
    enabled: false,
    _description: 'Shows a card with loan options on react overview',
    unhideCardOnStateChange: {
        enabled: true,
        _description:
            'Forcefully unhide the instant cash overview card on certain state transitions',
    },
    noLux: {
        enabled: false,
        _description: 'Will disable tracking events for lux',
    },
};
